export default __webpack_public_path__ + "static/steven-tyc-assistant-fire-chief-middlefield-vol-fire-company-2b95f86251825aeaf55e45e4f6d142b9.jpeg";